export default __webpack_public_path__ + "static/media/WaspScannerRed.0ad56ca9.svg";